import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthenticationService } from 'synergy-core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent {
  password!: string;
  passwordIsValid = false;
  constructor(
    private router: Router,
    private messageService: MessageService,
    public authenticationService: AuthenticationService
  ) {}

  ngOnInit() {}

  onLog(event: any) {
    if (event) {
      this.router.navigate(['/Dashboard']);
      //this.router.navigate(['/Dashboard']);
    } else {
      this.messageService.add({ key: 'tc', severity: 'error', summary: "Acceso denegado", detail: 'El id de usuario o el password son invalidos' });
    }
  }


}
